import { createFileRoute } from '@tanstack/react-router';
import Devices from 'containers/Devices';

export const Route = createFileRoute('/_authenticated/devices')({
  component: Devices,
});
